export const field = {
  appId: "x",
  appKey: "x",
  tokenKey: "token",
  domain: process.env.BASE_PATH,
  version: process.env.VERSION,
  debug: process.env.NODE_ENV !== "production",
  production: process.env.NODE_ENV == "production",
  type: process.env.TYPE
};



// WEBPACK FOOTER //
// ./src/assets/js/consts.js